<script setup lang="ts">
import UIVisualFiltersCategory from './UICarouselChipsCategory.vue'
import UIVisualFiltersColor from './UICarouselChipsColor.vue'
import UIVisualFiltersText from './UICarouselChipsText.vue'
import type {
  CarouselChipContent,
  ChipProps,
  UICarouselChipsProps,
} from './UICarouselChips.props'

const visualFiltersMapping: Record<string, Component> = {
  category: UIVisualFiltersCategory,
  color: UIVisualFiltersColor,
  text: UIVisualFiltersText,
}

const props = defineProps<UICarouselChipsProps>()

const emit = defineEmits(['chip-selected'])

const selectedChipLabel = ref<string>()

if (props.content && props.content.length > 0) {
  selectedChipLabel.value = props.content[0].chip.label
}

const selectChip = (content: CarouselChipContent) => {
  selectedChipLabel.value = content.chip.label
  emit('chip-selected', content)
}

const mapChipProps = (chip: CarouselChipContent): ChipProps => {
  const { products, ...rest } = chip
  return {
    ...rest,
    count: rest.xGen ? 10 : products.length,
  }
}
</script>

<template>
  <component
    :is="visualFiltersMapping[type]"
    v-for="(chip, index) in content"
    :key="`${chip}-${index}`"
    v-bind="mapChipProps(chip)"
    :chip-selected="chip.chip.label === selectedChipLabel"
    @click="selectChip(chip)"
  />
</template>
